<template>
    <div class="container-fluid">
        <div class="container-fluid" v-if="!pageResult2_ON">
            <div class="row mb-1">
              <div class="col-sm pb-1 text-start">
                <span class="badge rounded-pill bg-warning pull-left mt-1 py-2 px-4" style="font-size:18px; background:white">
                        <b>Lab Result : ป้อนผลแล็บ</b>
                </span>
                <div class="mt-2">
                  <div class="form-check form-check-inline mx-2" title="แสดงรายการสถานะใหม่" v-if="globalCorpInfo.StatusStep==1">
                    <input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="status0New">
                    <label class="form-check-label" for="inlineCheckbox1"><b>New</b> </label>
                  </div>
                  <div class="form-check form-check-inline mx-2" title="แสดงรายการที่รับเข้าห้องแล็บแล้ว(รอป้อนผล)" v-if="globalCorpInfo.StatusStep==0">
                    <input class="form-check-input" type="checkbox" id="inlineCheckbox2" v-model="status1Lab">
                    <label class="form-check-label" for="inlineCheckbox2"><b>Lab</b> </label>
                  </div>
                  <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่ป้อนผลแล้ว">
                    <input class="form-check-input" type="checkbox" id="inlineCheckbox3" v-model="status2Res">
                    <label class="form-check-label" for="inlineCheckbox3"><b>Resulted</b> </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-sm">
                    <div class="row">
                      <div class="col-4">
                          <!-- สาขาแล็บ -->
                          <div class="input-group input-group-sm">
                              <div class="input-group-prepend">
                              <span class="input-group-text" style="width:120px;">สาขา* :</span>
                              </div>
                              <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID">
                                  <option disabled value="">Please select one</option>
                                  <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                              </select>
                          </div>
                      </div>
                      <div class="col-8">
                          <!-- วันที่ใบสั่งตรวจ -->
                          <div class="input-group input-group-sm mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="width:120px;">วันที่เอกสาร</span>
                            </div>
                            <v-date-picker mode="date" v-model="dateFm" :masks="masks" title="วันที่เอกสารเริ่มต้น">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <input name="dateFm" ref="dateFm" style="width:120px;"
                                    class="bg-white border px-2 py-1 rounded"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                            <v-date-picker mode="date" v-model="dateTo" :masks="masks" title="วันที่เอกสารสิ้นสุด">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <input name="dateTo" ref="dateTo" style="width:120px;"
                                    class="bg-white border px-2 py-1 rounded"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                            <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
            <!-- ตารางใบสั่งตรวจ สถานะใหม่และป้อนผล ตามเงื่อนไขสาขาและวันที่เอกสาร -->
            <LabResult1View :datalists="datalists" :key="countRefresh"
                @onEntryResultEvent="entryResultPage"
                @onBackPageAfterBackStatusEvent="refreshAfterBackStatus"></LabResult1View>
        </div>
        <div class="container-fluid" v-if="pageResult2_ON">
            <LabResult2Entry
                :dataROHead="curRecord"
                :dataRemarklists="dataRemarklists"
                @onBackPageEvent="backPage"
                @onBackPageAfterSaveEvent="backPageAfterSave"></LabResult2Entry>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import LabResult1View from './LabResult1View.vue'
import LabResult2Entry from './LabResult2Entry.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'LabCreate',
  data () {
    return {
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      status0New: true,
      status1Lab: true,
      status2Res: false,
      // status3App: true,

      countRefresh: 0,
      // False : แสดงหน้าจอ View,  True : แสดงหน้าจอป้อนผลแล็บ
      pageResult2_ON: false,
      datalists: null,
      curRecord: null,
      PatName: '',
      action: 'new',
      // รายชื่อ พนง ในระบบ สำหรับเลือกใน Header Table
      dataOfficerlists: null,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null,
      // รายการ หมายเหตุ
      dataRemarklists: null
    }
  },
  created () {
    // Initial Value
    this.getOfficerData()
    this.getBranchData()
    this.getRemarkData()
  },
  mounted () {
    this.branchID = this.globalBranchID
    // ดึงข้อมูลรายการใบสั่งตรวจ
    this.getData()
  },
  components: {
    LabResult1View, LabResult2Entry
  },
  methods: {
    getRemarkData () {
      MyApiClient.get('getdata/remarks_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataRemarklists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    refreshAfterBackStatus () {
      // this.pageResult2_ON = !this.pageResult2_ON
      this.$nextTick(() => {
        $('#myLabResultTable').DataTable()
      })
      // Refresh ตารางใบสั่งตรวจ สถานะเปลี่ยน
      this.getData()
    },
    backPageAfterSave () {
      this.pageResult2_ON = !this.pageResult2_ON
      this.$nextTick(() => {
        $('#myLabResultTable').DataTable()
      })
      // Refresh ตารางใบสั่งตรวจ สถานะเปลี่ยน
      this.getData()
    },
    backPage () {
      this.pageResult2_ON = !this.pageResult2_ON
      this.$nextTick(() => {
        $('#myLabResultTable').DataTable()
      })
    },
    // เปิดหน้าต่างสำหรับป้อนผลแล็บ
    entryResultPage (row) {
      this.curRecord = row
      this.PatName = row.PatName
      this.pageResult2_ON = !this.pageResult2_ON
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getOfficerData () {
      MyApiClient.get('getdata/officers_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataOfficerlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData () {
      // -------- Date From -----------
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateFm = YYYY + '-' + MM + '-' + DD
      // -------- Date To -----------
      d = this.dateTo
      YYYY = d.getFullYear().toString()
      MM = ''
      DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateTo = YYYY + '-' + MM + '-' + DD
      var BranchID = this.branchID
      var Status0 = -1 // 0-New
      var Status1 = -1 // 1-Lab
      var Status2 = -1 // 2-Resulted
      if (this.status0New) {
        Status0 = 0 // 0-New
      }
      if (this.status1Lab) {
        Status1 = 1 // 1-Lab
      }
      if (this.status2Res) {
        Status2 = 2 // 2-Resulted
      }
      MyApiClient.get('getdata/labrequest_where_result.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&Status0=' + Status0 + '&Status1=' + Status1 + '&Status2=' + Status2)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // setTimeout(function () { this.$refs.myBranchTable.DataTable() }, 0)
          // console.log('on update ตาราง')
          setTimeout(function () { $('#myLabResultTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
